import axios from "../plugins/axios.plugin";

class PublicCartService {
  baseServicePath = "/api/public/cart";

  loadPublicCarts(payload) {
    return axios.post(`${this.baseServicePath}/load`, payload);
  }

  checkoutPublicCart(payload) {
    return axios.post(`${this.baseServicePath}/checkout`, payload);
  }

  validateCart() {
    return axios.post(`${this.baseServicePath}/verify?properties=1`);
  }
}

export const publicCartService = new PublicCartService();
